module.exports = __webpack_public_path__ + "static/options_outlook_local-174156eec3f04043ff06707f41d61508.png";